import { FC } from 'react'
import useWindowSize from 'components/util/useWindowSize'
import RightRobotCard from './common/RightRobotCard'
import { businessBankingStrings } from 'common/strings/business-banking-strings'

type Props = {}

const TideExclusiveOfferCard: FC<Props> = () => {
  const size = useWindowSize()
  return (
    <div className='d-flex flex-column gap-15 gap-lg-19'>
      <div
        style={{
          maxWidth: 980,
        }}
        className='d-flex flex-column gap-3 mx-auto text-center px-4'
      >
        <h2 className='fs-fluid-36-48 fw-semibold fs-fluid-36-80 lh-105 lh-lg-114 mb-0'>
          Helping you save time and money.
        </h2>
        <span className='fs-fluid-18-24 color-grey5 fw-semibold lh-119 lh-lg-140'>
          Hoxton Mix is delighted to introduce Tide as our exclusive business
          banking partner — helping you save time and money when managing your
          business finances. We've negotiated special offers with a range of
          trusted partners who provide small business services and solutions —
          visit our <a href='/marketplace/'>Marketplace</a> to explore them.
          Another great reason to join the Hoxton Mix.
        </span>
      </div>
      <RightRobotCard
        className='card_bg-tide-gradient color-white pt-lg-15'
        image={{
          alt: 'Tide robot with card',
          desktop: {
            dimensions: {
              height: 571,
              width: 596,
            },
            src: '/images/new/tide/tide-robot-cut.png',
          },
          mobile: {
            dimensions: {
              height: 639,
              width: 542,
            },
            src: '/images/new/tide/tide-robot-cut-mobile.png',
          },
        }}
        imageContainerWidth={size.isLgOrHigher ? '45%' : '100%'}
        imageStyle={{
          bottom: 0,
          height: '100%',
          maxWidth: '100%',
          objectFit: 'contain',
          objectPosition: 'right bottom',
        }}
      >
        <div className='d-flex flex-column flex-1 px-4 pt-9 pb-0 pt-lg-13 pb-lg-18 ps-lg-20 text-center text-lg-start justify-content-center'>
          <h2 className='fs-fluid-32-48 lh-114 fw-semibold mb-5 mb-lg-3 me-lg-n30'>
            Trusted by over 850,000 UK businesses, Tide is one of the UK's
            fastest-growing digital business banking platforms.
          </h2>
          <div className='fs-fluid-18-24 lh-140 fw-semibold mb-0 me-lg-n20'>
            <span className='color-pink2'>Tide</span> offers simple, powerful,
            free business bank accounts that can be opened in minutes, managed
            on mobile or desktop, and are FSCS-protected. With no credit checks
            and no monthly or annual fees, why not try{' '}
            <span className='color-pink2'>Tide</span> alongside your existing
            account? Spend less time on admin and more time running your
            business.
            <br />
            <br />
            <span className='fs-fluid-18-21 fw-normal'>
              Hoxton Mix members can claim an exclusive Tide offer —
              <strong>
                {businessBankingStrings.tideCashBackAmount} cashback
              </strong>
              . * Open an account using the code <strong>HOXTON</strong> to
              claim.
            </span>
            <br />
            <span className='fs-14 fw-normal'>* T&Cs apply.</span>
          </div>
        </div>
      </RightRobotCard>
    </div>
  )
}

export default TideExclusiveOfferCard
